<template>
  <el-popover ref="popover" trigger="click" :width="400" popper-class="popper-table" placement="left-start" :hide-after="0" @before-enter="onBeforeEnter">
    <template #reference>
      <span
        >{{ label }}(<span style="color: red">{{ count }} </span>)</span
      >
    </template>
    <div class="table" @click="nohide">
      <el-table :data="list" height="100%">
        <el-table-column prop="companyNumber" label="企业号" min-width="60" />
        <el-table-column prop="companyName" label="企业名称" min-width="90" />
        <el-table-column prop="subName" v-if="type == 3" label="账套名称" min-width="90" />
        <el-table-column v-if="type != 3" prop="count" label="审批单据数" min-width="90" />
        <el-table-column v-else prop="count" label="超预算项目" min-width="90" />
        <el-table-column label="操作" min-width="50">
          <template #default="{ row }">
            <el-link :underline="false" type="primary" @click="onClickLook(row)">查看</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-popover>
</template>
<script lang="ts" setup>
import { ElCard, ElMessage, ElPopover } from "element-plus";
import useCard, { Approval } from "./useCard";
import { useStore } from "vuex";
import { ref, watchPostEffect } from "vue";
import { useRouter } from "vue-router";
import usePower from "@/hooks/power/usePower";
import { POWER_APPROVE, POWER_BUDGET } from "@/config/power";
export interface List {
  companyNumber: string;
  companyName: string;
  count: number;
  subName: string;
  subId: string;
}
const store = useStore();
const router = useRouter();
const { judgePower } = usePower();
interface Props {
  label: string;
  list: List[];
  type?: 1 | 2 | 3; // 1: 带我查看, 2: 抄送我的, 3: 预算
  count: number;
}
const props = withDefaults(defineProps<Props>(), {
  type: 1,
});
const popover = ref<InstanceType<typeof ElPopover>>();
const card = ref<InstanceType<typeof ElCard>>();
const { width, onBeforeEnter } = useCard(card);

const onClick = (event: { stopPropagation: () => void }) => {
  if (([1, 2].includes(props.type) && !judgePower(POWER_APPROVE.APPROVE)) || (props.type == 3 && !judgePower(POWER_BUDGET.BUDGET))) {
    event.stopPropagation();
    ElMessage({ message: "您暂无此功能权限", type: "warning" });
  }
};

const emits = defineEmits(["nohide", "jump"]);
const nohide = () => {
  emits("nohide", true);
};
const onClickLook = (row: Approval) => {
  popover.value?.hide();
  const { type } = props;
  const data = {
    companyNumber: row.companyNumber,
    subId: row.subId,
    approve: "0",
    name: "",
  };
  switch (type) {
    case 1:
      data.approve = "2";
      data.name = "approve";
      break;
    case 2:
      data.approve = "4";
      data.name = "approve";
      break;
    case 3:
      data.name = "budgetCloud";
      break;
  }
  console.log(data, "datadatadatadata");

  emits("jump", data);
};
</script>

<style lang="less">
.el-popover.popper-table {
  --el-popover-padding: 0px;
}
</style>
<style lang="less" scoped>
.el-card {
  flex: 1;
  margin-right: @padding;
  cursor: pointer;
  &:last-child {
    margin: 0;
  }
  :deep(.el-card__body) {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    min-height: 90px;
    .right {
      display: flex;
      flex-direction: column;
      font-size: 12px;
      margin-bottom: 5px;
      margin-left: @padding;
      .number {
        font-size: 35px;
        margin-bottom: 6px;
        line-height: 1;
        font-weight: bold;
      }
      font-size: @fontSize;
    }
    .iconfont {
      width: 70px;
    }
  }
}
.popper-table {
  .table {
    height: 200px;
    .el-link {
      font-size: @fontSize;
      font-weight: normal;
    }
  }
}
</style>
